window.lazyBackground = function() {
	var lazyBackgrounds = [].slice.call(document.querySelectorAll("[lazy-background]"));
	// console.log(window.innerWidth);
	if ("IntersectionObserver" in window) {
		let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					// console.log(entry.target.getAttribute('lazy-background'));
					if(window.innerWidth > 420) {
						entry.target.setAttribute('style', `background-image: url('${entry.target.getAttribute('lazy-background')}')`);
					} else {
						if(entry.target.hasAttribute('lazy-background-mobile')) {
							// entry.target.setAttribute('style', entry.target.getAttribute('lazy-background-mobile'));
							entry.target.setAttribute('style', `background-image: url('${entry.target.getAttribute('lazy-background-mobile')}')`);
						} else {
							entry.target.setAttribute('style', `background-image: url('${entry.target.getAttribute('lazy-background')}')`);
						}
					}
					// entry.target.classList.add("visible");
					lazyBackgroundObserver.unobserve(entry.target);
					// entry.target.removeAttribute('lazy-background');
				}

			});
		});

		lazyBackgrounds.forEach(function(lazyBackground) {
			lazyBackgroundObserver.observe(lazyBackground);
		});
	}
};
window.imgLazy = function(){
	let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
	let active = false;

	const lazyLoad = function() {
		if (active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(lazyImage) {
					// console.log(lazyImage);
					if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
						// console.log();
						if(lazyImage.dataset.src !== '') {
							lazyImage.src = lazyImage.dataset.src;
							if(lazyImage.classList.contains('picture')) {
								let sours = lazyImage.parentElement.querySelectorAll('[data-srcset]');
								for(let i = 0; i < sours.length; i++){
									sours[i].srcset = sours[i].dataset.srcset;
									// console.log(sours[i]);
								}
							}
						} else if(lazyImage.dataset.srcset) {
							lazyImage.srcset = lazyImage.dataset.srcset;
						}
						lazyImage.classList.remove("lazy");

						lazyImages = lazyImages.filter(function(image) {
							return image !== lazyImage;
						});

						if (lazyImages.length === 0) {
							document.removeEventListener("scroll", lazyLoad);
							window.removeEventListener("resize", lazyLoad);
							window.removeEventListener("orientationchange", lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener("scroll", lazyLoad);
	window.addEventListener("resize", lazyLoad);
	window.addEventListener("orientationchange", lazyLoad);
	lazyLoad();
};

document.addEventListener("DOMContentLoaded", function() {
	lazyBackground();
	imgLazy();
});
lazyBackground();
imgLazy();



// WEBPACK FOOTER //
// ./libs/lazy-img/lazy-img.js